function tableHeader() {
    return {
        componentName: 'tableHeader',
        baseStyle: {
            display: 'contents'
        }
    };
}

export { tableHeader as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFibGVIZWFkZXIuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9jb21wb25lbnRzL3RhYmxlL3RhYmxlSGVhZGVyLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbXBvbmVudFN0eWxlIH0gZnJvbSAnLi4vLi4vdHlwZXMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB0YWJsZUhlYWRlcigpOiBDb21wb25lbnRTdHlsZSB7XG4gIHJldHVybiB7XG4gICAgY29tcG9uZW50TmFtZTogJ3RhYmxlSGVhZGVyJyxcbiAgICBiYXNlU3R5bGU6IHtcbiAgICAgIGRpc3BsYXk6ICdjb250ZW50cydcbiAgICB9XG4gIH07XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWMsU0FBVSxXQUFXLEdBQUE7SUFDakMsT0FBTztBQUNMLFFBQUEsYUFBYSxFQUFFLGFBQWE7QUFDNUIsUUFBQSxTQUFTLEVBQUU7QUFDVCxZQUFBLE9BQU8sRUFBRSxVQUFVO0FBQ3BCLFNBQUE7S0FDRixDQUFDO0FBQ0o7Ozs7In0=
